import { IMixpanelEventBuilder, TrackEventParams } from "./types";

export class MixpanelEventBuilder implements IMixpanelEventBuilder {
  private eventName?: string;
  private properties: Record<string, any> = {};
  private orgId?: string;
  private callback?: () => void;

  constructor(
    private executeTrackEvent: (params: TrackEventParams) => void,
    private shouldTrack: () => boolean,
    defaultOrgId?: string
  ) {
    this.orgId = defaultOrgId;
  }

  setEventName(name: string): IMixpanelEventBuilder {
    this.eventName = name;
    return this;
  }

  setOrgId(orgId: string): IMixpanelEventBuilder {
    this.orgId = orgId;
    return this;
  }

  addProperty(key: string, value: any): IMixpanelEventBuilder {
    this.properties[key] = value;
    return this;
  }

  addProperties(properties: Record<string, any>): IMixpanelEventBuilder {
    Object.assign(this.properties, properties);
    return this;
  }

  setCallback(callback: () => void): IMixpanelEventBuilder {
    this.callback = callback;
    return this;
  }

  track(): void {
    if (!this.shouldTrack()) {
      return;
    }

    if (!this.eventName) {
      throw new Error("Event name must be set before tracking");
    }

    if (!this.orgId) {
      throw new Error("Organization ID must be set before tracking. Either set it during service initialization or call setOrgId() on the builder.");
    }

    this.executeTrackEvent({
      eventName: this.eventName,
      properties: this.properties,
      orgId: this.orgId,
      callback: this.callback,
    });
  }
}
